import React from 'react';
import AddIcon from '@material-ui/icons/Add';
import { Button } from '@material-ui/core';
import styled from 'styled-components';

import ThesisItem from './ThesisItem';

const ThesesList = ({ data: theses, onAddThesis, onChange, onDelete }) => {
  return (
    <Container>
      <Title>Trabajos de titulación</Title>
      <span> (opcional)</span>
      {theses.map((thesis, index) => (
        <ThesisItem
          key={index}
          data={thesis}
          index={index}
          onChange={onChange}
          onDelete={onDelete}
        />
      ))}
      {theses.length > 0 &&
        theses[0].name !== '' &&
        theses[0].type !== '' &&
        theses[0].status !== '' && (
          <Button
            variant='contained'
            color='primary'
            startIcon={<AddIcon />}
            onClick={onAddThesis}
          >
            Agregar trabajo
          </Button>
        )}
    </Container>
  );
};

const Container = styled.section`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 95%;
  justify-content: flex-start;
`;

const Title = styled.h3`
  margin: 0;
  text-transform: uppercase;
`;

export default ThesesList;
